import {  Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';


const modalBackdropStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    // The key style for the frosted glass effect:
    backdropFilter: 'blur(4px)',
    zIndex: 1050,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

// --- COMPONENT ---

export const UpgradePlan = ({ moduleName = "Detailed Reporting" }) => {

    const navigate = useNavigate()
    const handleUpgradeClick = () => {
        navigate("/plans")
    };

    return (
        <div style={modalBackdropStyle}>
            <Card className="shadow-lg" style={{
                maxWidth: '450px',
                width: '100%',
                border: 'none',
                borderRadius: '12px',
                zIndex: 1051,
            }}>
                <Card.Body className="text-center p-5">

                    <div style={{
                        width: '120px',
                        height: '120px',
                        backgroundColor: '#f7e8f0',
                        borderRadius: '50%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: `3px solid #7a3a5e`,
                        margin: '0 auto 1.5rem',
                    }}>
                        <i className="bi bi-gear-wide-connected" style={{ fontSize: '3rem', color: "#7a3a5e" }}></i>
                    </div>
                    <Card.Title style={{
                        fontSize: '1.4rem',
                        fontWeight: '700',
                        color: '#333',
                        marginBottom: '1rem',
                        textWrap: "balance"
                    }}>
                        Upgrade your plan to view <span style={{ color: "#7a3a5e" }}>{moduleName}</span>
                    </Card.Title>
                    <Card.Text className="text-muted mb-4">
                        Unlock full access to advanced features, detailed analytics, and enterprise-grade security by upgrading your subscription.
                    </Card.Text>
                    <div className='d-flex flex-column gap-2'>
                        <Button
                            variant="primary"
                            size="lg"
                            onClick={handleUpgradeClick}
                            className='btn btn-default shadow'
                        >
                            View Upgrade Options
                        </Button>
                        <Button
                            variant="primary"
                            size="lg"
                            onClick={() => navigate("/dashboard")}
                            className='btn btn-default shadow'
                        >
                            Return To Dashboard
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

